module.exports = __webpack_public_path__ + "img/47.8b3b819e.jpg";